<script setup lang="ts">
import { resolveComponent } from 'vue'
import { isString } from 'lodash-es'

const { justify, modal, iconStart, iconEnd } = defineProps<{
  link?: StoryBlokLink
  justify?: string
  target?: string
  modal?: any[]
  iconStart?: StoryBlokIcon | string
  iconEnd?: StoryBlokIcon | string
  showFullOnMobile?: boolean
}>()
const isModalOpen = ref(false)
const modalComponent = modal?.length && resolveComponent(modal[0]?.reference?.[0].reference.content.component || modal[0].component)
function resolveIcon(icon?: StoryBlokIcon | string) {
  if (!icon) return undefined
  else if (isString(icon)) return icon
  else if (icon?.icon) return `${icon.type}-${icon.icon}`
}
const modalData = modal?.length && (modal[0]?.reference?.[0].reference.content || modal[0])
</script>

<template>
  <div :class="[justify]" class="flex">
    <StoryblokLink class="flex w-full" :target="target" v-bind="link" @click.stop="modal?.length && $event.preventDefault()">
      <BaseButton
        :block="justify === '' || showFullOnMobile"
        v-bind="$attrs"
        :icon-start="resolveIcon(iconStart)"
        :icon-end="resolveIcon(iconEnd)"
        @click="isModalOpen = true"
      >
        <slot />
      </BaseButton>
    </StoryblokLink>
  </div>
  <component :is="modalComponent" v-if="modal?.length && isModalOpen" v-model:model-value="isModalOpen" v-bind="modalData" @close="isModalOpen = false" />
</template>

<style lang="scss" scoped>
</style>
